/**
 * Age Verification Extension for AddToCartComponent
 * 
 * This file extends the AddToCartComponent with age verification functionality.
 * It should only be loaded when the age-verification-modal section is present.
 */

import ageVerificationService from '@theme/age-verification-service';

customElements.whenDefined('add-to-cart-component').then(() => {
  const AddToCartComponent = customElements.get('add-to-cart-component');
  if (!AddToCartComponent) return;
  
  const originalHandleClick = AddToCartComponent.prototype.handleClick;

  /**
   * Extended handleClick with age verification gate
   * @param {MouseEvent & {target: HTMLElement}} event
   */
  AddToCartComponent.prototype.handleClick = function(event) {
    const requiresAge =
      this.getAttribute('data-requires-age-verification') === 'true';

    if (requiresAge) {
      event.preventDefault();
      event.stopPropagation();
      
      ageVerificationService.requestVerification(() => {
        originalHandleClick.call(this, event);
        
        const form = this.closest('form');
        if (form instanceof HTMLFormElement) {
          form.requestSubmit();
        }
      });
      return;
    }

    originalHandleClick.call(this, event);
  };
});


